module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("S")])]), _vm._v("eneca Houston adjusted the three-way mirrored panels until she could view her full-length image from several angles. The navy draped silk taffeta dress Luis Navarro had designed for her was a perfect fit. The garment, ending at her knees, was reminiscent of old Hollywood glamour with a modern twist—asymmetric, one-shoulder styling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I love it,” she crooned, “but are you certain it’s not too dressy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luis shook his head and waved his hand as if swatting away an annoying insect. “Don’t go there, Seneca. What you don’t want to do is look like everyone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her friend was right. She didn’t want to look like anyone else, but stand out. After all, she was a model, and it was her job to perfect her personal three Ps: preening, posturing and strutting like a peacock.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("She’d recently celebrated her second year as a model, and her career was stuck in a rut. It wasn’t as if she didn’t get offers. However, they weren’t the offers Seneca needed to advance in ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("her profession. The monies she earned as a commercial model paid the rent on the two-bedroom brownstone apartment she shared with an aspiring actress, but left her unable to indulge in her only guilty pleasure: a monthly Broadway play.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What she didn’t want to do for the next ten to twenty years was spend hours under hot lights doing catalogs and magazine shoots. Seneca knew she had the face and body for runway, yet that would not become a reality unless she signed with an agency.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although working as a freelance model afforded her the freedom to accept or decline assignments, she worked longer hours than runway models, earning far less. Doing print ads kept, as her grandmother used to say, “the wolf from the door,” but she was tired of having to count pennies to make ends meet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unfortunately, frugality had become a part of her day-today existence, which was totally the opposite of her generous personality. If she had one cookie she would share it with anyone who wanted a piece. And she was willing to do anything short of prostitution to avoid moving back home with her domineering mother. That, Seneca vowed, was not an option.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hopefully, everything would change tonight. A photographer who’d befriended her when she did a major department-store catalog shoot had promised to introduce her to the head of BG Management Agency. Mitchell Leon told her Booth Gordon was always looking for a new face and new talent, and he’d told the talent agent that she was fashion’s next “It” girl. Seneca knew she had the goods. Now all she had to do was sell them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Reaching for a necklace made of a double row of carved twelve-millimeter lapis and pale green jade beads with a large clasp encrusted with pearls, she slipped it around her neck ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("and adjusted it until the butterfly-designed clasp rested at the base of her throat. She had debated whether to wear her hair pinned up or down around her shoulders, then opted for a loose chignon. Luis had complained that the hairstyle was too severe for her age, but Seneca had overruled him, leaving wisps to fall around her ears and conceal her pierced lobes.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dangling the straps of a pair of dark blue, silk-covered stilettos from his forefinger, Luis approached Seneca. If he hadn’t been involved with an extremely wealthy and much-married older woman who’d financed his own fashion collection, he knew he would’ve asked Seneca Houston to become his wife. Seneca knew he liked her. But what she didn’t know was how much. Not only had she become his muse but also his obsession.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Going to one knee, he grasped the ankle of her right foot and slipped the slingback onto her narrow foot. Luis felt the warmth of her hand on his shoulder as she leaned down to keep her balance. He eased the strap up and over her heel, then repeated the motion with the left foot. The heels put Seneca’s head over the six-foot mark, four inches taller than his own five-ten height.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reaching for her hands, he brought them to his mouth, kissing her knuckles. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Buena suerte, mia mariposa.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca smiled, rose-pink lips parting. Straight, professionally whitened teeth in a face the color of toasted pecans pulled his gaze to linger on her mouth. “Thank you, Luis.” She pressed her cheek to his while affecting an air kiss.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Luis stared at the tall young woman whose curvy body belied its slimness. Whereas most high-fashion models were waiflike, Seneca Houston was slender and womanly. Viewed from the front or rear, no one would ever mistake her for a tall, thin boy. Her face was as exquisite as her body; the first time he saw her he’d stared rudely, as if entranced by a creature ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("who had cast her spell over him. It was only when he mustered enough nerve to approach her that he’d discovered she was a freshman at New York University.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d convinced her to try modeling part-time, hooking her up with professional photographer Mitchell Leon, who’d taken the photos she needed for a portfolio. Luis had tried to get her to sign with an agency, but Seneca refused, declaring she wanted independence and a semblance of autonomy when it came to selecting her assignments. He knew she was destined for more than just being a commercial and print model, and with Mitchell’s intervention he was able to convince her to meet Booth Gordon. If anyone could make Seneca a supermodel it was Booth “the Barracuda” Gordon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca glanced at the clock on the bedside table in Luis’s cramped bedroom. She knew the designer could afford to move out of the fifth-floor walk-up apartment building, but she suspected he didn’t want to leave the Hell’s Kitchen neighborhood where he’d been born and raised. His parents, grandparents and many cousins still lived in public housing within walking distance of Lincoln Center.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have to leave now. The driver is probably downstairs waiting for me.” She smiled at the designer, who on occasion had been mistaken for Marc Anthony. The only thing Luis and the talented singer shared was culture. Both were Puerto Rican.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll go downstairs with you,” he volunteered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Walking out of the bedroom, Luis following, she left the one-bedroom apartment and managed to navigate the marble stairs to the building lobby in the stilettos without mishap.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("It was late spring, and dusk was descending on the island of Manhattan. It was also Seneca’s favorite season. The days were warm and the nights cool enough to sleep without the ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("incessant drone of the air-conditioning unit. She spied a black Lincoln town car parked halfway the block.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The driver got out of the limousine at their approach. “I’ll call you with the details tomorrow,” she whispered to the man who’d not only changed her, but also her life. She slipped onto the rear seat of the limo, waving at Luis standing on the sidewalk until the driver maneuvered away from the curb.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The driver opened the rear door to the town car, surreptitiously shifting his gaze so he wouldn’t be caught gawking at the long, smooth legs of the most beautiful woman he’d had the privilege of driving for his family-owned livery company.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He inclined his head as if she were royalty while handing her his business card. “Please call me when you’re ready to leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca Houston nodded at the man, whose head came to her shoulder. She stood two inches above the six-foot mark in four-inch stilettos. Folding the card in half, she slipped it into the tiny evening purse looped over her body and suspended from a midnight-blue silk strap.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will,” she promised.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca had borrowed money from her roommate to rent the limo rather than take a yellow cab to a dinner party hosted by Booth Gordon. She’d promised to return the money once she landed another modeling assignment, but Electra Reece-Jacobs had brushed her off with a wave of her bejeweled hand and a “whateva.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Seneca couldn’t brush off things with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("whatever,")]), _vm._v(" only because she wasn’t where she wanted to be. She’d begun modeling within five months of graduating from high school. But renting the limo had become an extravagant extra. Living in Manhattan had its advantages and disadvantages. The ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("advantage was she could take public transportation to go-sees and the disadvantage was that everything, especially rent, was higher than it was in the suburbs or other boroughs. Tonight, she prayed, that would change—if she could convince Booth Gordon to take her on as his client.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning on the silk-covered designer heels, she walked toward the entrance to the canopied, doorman Upper East Side high-rise luxury building with views of East River bridges connecting Manhattan to the outer boroughs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. Gordon is in apartment 2410. The even-numbered floors elevators are through the lobby on your right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca gave him her most dazzling smile, a smile that she could turn on and off like a spotlight. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had to psych herself up before she met the manager/agent extraordinaire. There were circulating rumors that Booth Gordon could sell ice cream on the summit of Mount Everest. Whatever the rumors, Seneca wanted to discover if the man was as good as everyone said he was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Walking into the elevator, she punched the button for the twenty-fourth floor, and within seconds the doors closed and the car rose silently and swiftly to the designated floor. The doors opened and she found herself face-to-face with the man who was much shorter in person than Seneca had expected him to be. Perhaps it was his leonine head that made him appear taller and larger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a man in his early forties, he was in good physical condition. She estimated he stood about five-nine and weighed about one-seventy. His rakishly long black hair was graying at the temples, and brilliant blue-green eyes in a deeply tanned face directed attention away from his too-large nose and thin lips. Although casually dressed in a white linen shirt, black slacks in the same fabric and imported slip-ons he radiated power and confidence.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Professionally arched eyebrows lifted a fraction when she tilted her chin and gave Booth a curious stare. “Mr. Gordon?” Seneca knew exactly who he was, and knew instinctually to play to his inflated ego.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Booth Gordon couldn’t bring his rapt gaze away from the woman with a golden-brown complexion, large, slanting dark eyes and perfectly symmetrical features usually seen in the paintings of Renaissance masters. She could’ve been Sandro Botticelli’s model for the wood nymphs in his “Primavera” or his famed “Birth of Venus.” Even her hair was perfect. It was raven-black, with wisps framing her extraordinary face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Taking her hand, Booth examined her long, slender fingers. Her nails were natural and covered with a pale beige polish. “Miss Seneca Houston, I presume.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca gave him a demure smile. “You presume correctly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His gaze fused with Seneca’s, Booth brought her hand to his mouth and kissed it. “When Mitch told me he was inviting someone I should take a look at I never would’ve imagined someone like you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was something about the way Booth Gordon was leering at Seneca that made her feel as if he were undressing her with his eyes. He had to know what she looked like, because Mitchell Leon had sent Booth a number of photos of her. “Are you going to continue to entertain me in the hall, or are you going to introduce me to your other guests?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Annoyance swept over Booth like an electric shock. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who does this bitch think she is?")]), _vm._v(" “What makes you think you’re one of my guests?” he spat out nastily.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Seneca refused to take umbrage at his tone. She’d grown up with a waspish, controlling, condescending mother who complained about any and everything, so if Booth Gordon thought he frightened her he was mistaken. Although she ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("wanted him to represent her, she had no intention of letting him intimidate her.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If I’m not a guest, then why was my name on the guest list?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Booth released her hand and crossed his arms over his chest. “Maybe it’s because I was curious. I usually take Mitch’s word when he asks for something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Holding her arms out at her sides, Seneca pivoted slowly, giving the egotistical man a good look at what he was about to lose. “Was Mitchell telling the truth?” she crooned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Booth bit his lip to keep from smiling. The beautiful Amazon definitely had him at a disadvantage. She was perfect coming and going, and the dress she wore appeared to have been designed expressly for her. He couldn’t stop the smile spreading across his deeply tanned face. He stared at her shoes, recognizing the designer’s signature red soles, but the design of her dress was unfamiliar. As an agent with several models on his roster, he’d familiarized himself with every major and upcoming clothing designer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who are you wearing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was Seneca’s turn to conceal a smile. “Luis Navarro.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I never heard of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you will,” she promised.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Booth’s black eyebrows flickered. “When’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When you agree to represent me,” she said confidently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you that certain I’ll agree to represent you?” Booth countered with a note of annoyance creeping into his normally soft modulated voice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Suddenly Seneca felt as if she’d been given the challenge to try and push a boulder up a mountain with the aid of only a teaspoon. She’d grown up basking in male attention, and by the time she’d entered adolescence she’d come to realize her power over the opposite sex. A demure smile was usually ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("all she needed to get what she wanted from them. But Booth Gordon was proving her wrong. Mitchell Leon had told her that she would have Booth eating out of her hand within seconds of their meeting.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If not you, then there will be someone else.” Turning, she slapped the button for the elevator, then found her wrist caught between Booth’s fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Using a minimum of effort, Booth pulled Seneca Houston to stand between his outstretched legs. “There’s not going to be anyone else. And there’s another thing,” he said cryptically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you want to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Booth smiled. It was as if she could read his mind. “I need to know if you have any skeletons in your closet like pregnancies, abortions, and husband, ex-husband or crazy-ass boyfriends.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seneca smiled. “No to any of the aforementioned.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He knew it was time to stop playing mind games with the woman who was even more stunning in person than she was in her photos. “If you give me absolute control of your career I will make you a bigger supermodel than any that has come before you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The seconds ticked when Seneca met Booth’s resolute gaze. “I’ll agree if it doesn’t interfere with my personal life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Booth released her wrist, threading his fingers through hers. “I’ll call my attorney and have him draw up a contract. We probably can get everything executed within a week. If you don’t have a passport, then get one. I’m going to make a few calls and hopefully get you into a show in Paris for the fall.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head. “I’m not going to sign anything until my lawyer says it’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A hint of a smile softened the agent’s thin lips. “You have a lawyer?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Seneca nodded. “My roommate’s father is a lawyer, as are ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("her brother and grandfather, and I won’t sign anything without their approval.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A full smile deepened the lines around Booth’s brilliant eyes. “And I don’t want you to. I’ve monopolized you long enough. Come and let me introduce you to my other guests.”")])])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page24"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e758cc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426864223_ch01.vue
// module id = 75
// module chunks = 0